/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportSort,
    ReportSortFromJSON,
    ReportSortFromJSONTyped,
    ReportSortToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdminSearchVehicleOrderRequest
 */
export interface AdminSearchVehicleOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminSearchVehicleOrderRequest
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminSearchVehicleOrderRequest
     */
    pageSize?: number;
    /**
     * 
     * @type {ReportSort}
     * @memberof AdminSearchVehicleOrderRequest
     */
    sortMode?: ReportSort;
    /**
     * 
     * @type {boolean}
     * @memberof AdminSearchVehicleOrderRequest
     */
    onlyCompleted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AdminSearchVehicleOrderRequest
     */
    searchQuery?: string | null;
}

export function AdminSearchVehicleOrderRequestFromJSON(json: any): AdminSearchVehicleOrderRequest {
    return AdminSearchVehicleOrderRequestFromJSONTyped(json, false);
}

export function AdminSearchVehicleOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminSearchVehicleOrderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': !exists(json, 'page') ? undefined : json['page'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'sortMode': !exists(json, 'sortMode') ? undefined : ReportSortFromJSON(json['sortMode']),
        'onlyCompleted': !exists(json, 'onlyCompleted') ? undefined : json['onlyCompleted'],
        'searchQuery': !exists(json, 'searchQuery') ? undefined : json['searchQuery'],
    };
}

export function AdminSearchVehicleOrderRequestToJSON(value?: AdminSearchVehicleOrderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'pageSize': value.pageSize,
        'sortMode': ReportSortToJSON(value.sortMode),
        'onlyCompleted': value.onlyCompleted,
        'searchQuery': value.searchQuery,
    };
}


